import React, {useEffect, useState, useRef} from 'react'
import {Row, Col, Tabs, Card, Button, Tooltip} from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import { connect } from 'react-redux'

import Azips from './Azips'
import Hoks from './Hoks'
import Dxa from './Dxa'
import Edv from './Edv'

import './index.scss'
import {TabsInfoIco} from "../../../../../modules/CustomIcons";
import {useHistory, useLocation} from "react-router-dom";
import CustomTooltip from "components/Tooltip";
import {getPathnameByIndex} from "../../../../services/helper";
import {checkPermission} from "../../../../services/permission";
import {getCurrentCompany} from "../../../../services/user";
import { useTranslation } from 'react-i18next'
import noSelected from "assets/images/noSelectedTransfer.svg";
import messageList from "assets/locales/translate.json";
import {getMessageLists} from "store/actions/home";
import { useConveyer } from "@egjs/react-conveyer";


const TransferDomestic: React.FC<any> = ({companyData,messageList}) => {
    const {t} = useTranslation()
    const ref = useRef<HTMLDivElement>(null);
    useConveyer(ref, {
        horizontal: true,
    });
    const language = localStorage.getItem("i18nextLng")
    const [textArray_Dxa,setTextArray_Dxa] = useState([])
    const [textArray_Azips,setTextArray_Azips] = useState([])
    const [textArray_edv,setTextArray_edv] = useState([])
    const [textArray_Hoks,setTextArray_Hoks] = useState([])
    const fetchessageData = async () => {

      let lang_text_azips = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_AZIPS')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_AZIPS')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_AZIPS')?.textENG :"") : "";
        const array_azips =lang_text_azips !== null && lang_text_azips !== undefined ? lang_text_azips.split("|") : [];

        let lang_text_hoks = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_XOHKS')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_XOHKS')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_XOHKS')?.textENG :"") : "";

        const array_hoks = lang_text_hoks !== null && lang_text_hoks !== undefined? lang_text_hoks.split("|") : [];

        let lang_text_dxa = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_DXA')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_DXA')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_DXA')?.textENG :"") : "";

        const array_dxa = lang_text_dxa !== null && lang_text_dxa !== undefined ? lang_text_dxa.split("|") : []

        let lang_text_edv = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.TR_VAT')?.textAZE :
            language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_VAT')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.TR_VAT')?.textENG :"") : "";

        const array_edv = lang_text_edv !== null && lang_text_edv !== undefined ? lang_text_edv.split("|") : []

        setTextArray_Dxa(array_dxa);
        setTextArray_Azips(array_azips)
        setTextArray_Hoks(array_hoks)
        setTextArray_edv(array_edv)
  };
    useEffect(() => {
        fetchessageData()
    }, [messageList,language])

    const TooltipMessageAzips = `
    ${
        textArray_Azips.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageHoks = `
    ${
        textArray_Hoks.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageDxa = `
    ${
        textArray_Dxa.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `

    const TooltipMessageEdv = `
    ${
        textArray_edv.map((line:any,index:number) => {

            return(

                line.startsWith('http') ?
                    `<a href=${line} key=${index} > ${line} </a>`
                    :
                    `<p key=${index}> ${line} </p>`
            )
        }).join('')
    }
    `
  const tabInnerData: Array<any> = [
    {
      index: 1,
      title: 'AZİPS',
       description :TooltipMessageAzips,
      content: <Azips/>,
      path : '/new_transfer/domestic/azips',
      permissionKey : 'AZIPS',
    },
    {
      index: 2,
      title: 'XÖHKS',
      description :TooltipMessageHoks,
      content: <Hoks/>,
      path : '/new_transfer/domestic/hoks',
      permissionKey : 'XOHKS',
    },
      {
          index: 3,
          title: t("home.budgetSTA"),
           description : TooltipMessageDxa,
          content: <Dxa/>,
          path : '/new_transfer/domestic/dxa',
          permissionKey : 'DXA',
      },
      {
          index: 4,
          title: t("home.budgetVAT"),
          description : TooltipMessageEdv,
          content: <Edv/>,
          path : '/new_transfer/domestic/edv',
          permissionKey : 'EDV',
      },
  ]

    const { TabPane } = Tabs;
    const history = useHistory();
    const location = useLocation();
    const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
    const [tabActiveKey, setTabActiveKey] = useState<number>(find_tab?.index);

    useEffect(() => {
        const find_tab=tabInnerData.find(row => row.path.includes(getPathnameByIndex(2)));
        setTabActiveKey(find_tab?.index);

    }, [location, companyData])

    const tabOnChange = (activeKey) => {
        setTabActiveKey(old_key => activeKey);

        const find_row=tabInnerData.find(row => row.index==activeKey);

        if (find_row){
            history.push(find_row.path);
        }
    };

  return (
    <Row className='transfer_child_tabs' ref={ref}>
      <Col span={24} style={{minWidth: "750px"}}>
          <Tabs
              activeKey={`${tabActiveKey}`}
              onChange={tabOnChange}
              id="transferTab"
              destroyInactiveTabPane={true}
          >

            {tabInnerData &&
              tabInnerData.map((item, index) => {
                  let span_class=(tabInnerData.length - 1 == index) ? 'is_last_span' : '';

                  return checkPermission(item.permissionKey) && (
                      <TabPane className={span_class} tab={
                          <span className={`transfer_child_tabs_${item.index} ${span_class}`} >
                      {item.title}

                              <CustomTooltip
                                  title={item.description}
                              >
                              <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                          </CustomTooltip>

                      </span>} key={item.index}>
                          {item.content}
                      </TabPane>
                  )
                /*return checkPermission(item.permissionKey) && (
                  <TabPane tab={
                        <span>
                            {item.title}
                            <CustomTooltip
                                title={item.description}
                            >
                              <Button type={'ghost'} className={'transparent'} icon={<TabsInfoIco />} />
                            </CustomTooltip>
                        </span>
                    } key={item.index}>
                    {item.content}
                  </TabPane>
                )*/
              })}
          </Tabs>
      </Col>
        { tabActiveKey === undefined && <span className={'noSelected'}>{t("newTransfer.noSelectedTransfer")}
            <img src={noSelected}/>
              </span> }
    </Row>
  )
}
const mapDispatchToProps = { getMessageLists }
const mapStateToProps = (state: any) => ({
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany(),
    messageList: state.home.messageList,
})
export default connect(mapStateToProps, mapDispatchToProps)(TransferDomestic)
